import React from "react";
import "./Vip_details_history.css";
import Vip_all_details_history from "../../Vip_details_history/Vip_all_details_history";

function Vip_details_history() {
  return (
    <>
      <section className="Rebate_Ratio">
       <Vip_all_details_history/>
      </section>
    </>
  );
}

export default Vip_details_history;
